<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <!-- header info -->
                <v-row class="pa-4 pb-0">
                    <h3>Select tasks for user</h3>
                </v-row> 
                <v-row class="pa-4 pb-0">
                    <h5>{{ gebr_code }} : {{ gebr_naam }}</h5>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                    </v-col>
                </v-row> 
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="px-0" >
                            <ul class="ul_style">
                                <li>
                                    <v-data-table 
                                        dense 
                                        hide-default-footer
                                        show-select
                                        return-object

                                        v-model="selected_tasks"
                                        :headers="getHeaders()" 
                                        :search="search"
                                        :items="all_tasks"
                                        item-key="taak_code"
                                        :disable-pagination=true>
                                    </v-data-table>
                                </li>
                            </ul>
                        </v-card> 
                    </v-col>
                </v-row> 
                <v-row class="pa-4 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="pr-5" small v-on:click="saveSelect">Save</v-btn>
                    &nbsp;
                    <v-btn color="primary" small v-on:click="closeSelect">Close</v-btn> 
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },             
        data() {
            return {
                gebr_encrid: "",
                gebr_code: "",
                gebr_naam: "",
                search: "",
                all_tasks: [],
                selected_tasks: [],
                dialog: false,
            }
        },
        methods: {  
            getUserTaak() {
                this.$axios.post("ares/json/ares/syst/authorization/getUserTaak.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getUserTaak"
                    },
                    getUserTaak: {
                        gebr_encrid: this.gebr_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.all_tasks = res.data.getUserTaak;

                        this.selected_tasks = [];
                        for (let i = 0; i < this.all_tasks.length; i++) {
                            if (this.all_tasks[i].gebr_authorized) {
                                this.selected_tasks.push(this.all_tasks[i]);  
                            }           
                        }

                        this.dialog = true;
                    }
                });
            },    
            openSelect(user) {
                this.gebr_encrid = user.gebr_encrid;
                this.gebr_code = user.gebr_code;
                this.gebr_naam = user.gebr_naam;
                this.getUserTaak();
            },
            saveSelect() {
                let selection = [];
                for (let i = 0; i < this.selected_tasks.length; i++) {
                    selection.push(this.selected_tasks[i].taak_code);         
                }                
                this.$axios.post("ares/json/ares/syst/authorization/updUserTaak.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updUserTaak"
                    },
                    updUserTaak: {
                        gebr_encrid: this.gebr_encrid,
                        selected_tasks: selection,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // Users updates, update parent & leave dialog
                        this.$emit("updateData"); 
                        this.dialog = false;
                    }
                });
            },
            closeSelect() {
                this.dialog = false;
            },
            getHeaders() {
                return [
                    { text: "Taak", value: "taak_code", sortable: true},
                    // { text: "Program(s)", value: "taak_prog", sortable: false},
                    { text: "Description", value: "taak_oms", sortable: false},
                ];
            },	            
        },
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 6px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }

	.flex{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 315px;
        overflow-y: auto;
    }
</style>